export const sessionStorageItemNameAppJWT = 'yesplanapp_jwt';
export const sessionStorageItemNameEmptyCustomData = 'yesplanapp-emptycd';
export const sessionStorageItemNameEventsListPagination =
  'yesplanapp-eventslistpagination';
